import React from 'react';
import { withTranslation } from 'react-i18next';
import type { IProps } from './add-prospect-manually-modal-container';
import AddProspectForm from '../../../../../../../shared/components/add-prospect-form';
import Modal from '../../../../../../../shared/design-system/components/atoms/modal';
import eventBus from '../../../../../../../shared/utils/event-bus';
import { constants } from '../../../../../../../shared/enums/constants';

class AddProspectManuallyModal extends React.Component<IProps> {
  onCloseHandler = () => {
    const { onClose } = this.props;
    onClose();
    eventBus.dispatch(constants.MODAL_HANDLER, { isModalOpened: false });
  };

  onSubmitHandler = () => {
    eventBus.dispatch(constants.MODAL_HANDLER, { isModalOpened: false });
  };

  render() {
    const { show, t } = this.props;

    return (
      <>
        <Modal
          show={show}
          className="h-100 add-prospect"
          titleContent="Add Prospect"
          onClose={this.onCloseHandler}
          hideFooter={true}
          submitButtonText={t('labels.save')}
          backdrop="static"
        >
          <AddProspectForm
            onClose={this.onCloseHandler}
            onSubmit={this.onSubmitHandler}
            buttonTitle={t('labels.save')}
          />
        </Modal>
      </>
    );
  }
}

export default withTranslation()(AddProspectManuallyModal);
